import $ from "jquery";

const cm_navbar_dropdown_container = "cm-navbar-dropdown-container";
const mobileBrandDivHeight = 68;
let cm_navbar_item_trigger = null;


// #cm-navbar-dropdown-bar的mousemove事件
function cm_navbar_dropdown_bar_mousemove() {
    // 設定不隱藏#cm-navbar-dropdown-bar
    document.querySelector("#cm-navbar-dropdown-bar").dataset["hide"] = "false";
}


// #cm-navbar-dropdown-bar的mouseout事件
function cm_navbar_dropdown_bar_mouseout() {
    document.querySelector("#cm-navbar-dropdown-bar").dataset["hide"] = "true";
    setTimeout(function () {
        if (document.querySelector("#cm-navbar-dropdown-bar").dataset["hide"] == "true") {
            // 隱藏
            document.querySelector("#cm-navbar-dropdown-bar").style.display = "none";
            document.querySelector("#cm-navbar-dropdown-container").style.display = "none";

            // 移除#cm-navbar-dropdown-bar的mousemove和mouseout事件
            document.querySelector("#cm-navbar-dropdown-bar").removeEventListener("mousemove", cm_navbar_dropdown_bar_mousemove);
            document.querySelector("#cm-navbar-dropdown-bar").removeEventListener("mouseout", cm_navbar_dropdown_bar_mouseout);

            // 清除觸發的元素
            cm_navbar_item_trigger = null;
        }
    }, 100);
}


// 為#cm-navbar-dropdown-container添加padding-left，使得#cm-navbar-dropdown-container中心點可以對齊被觸發的一級項目的中心點
function cm_navbar_dropdown_container_add_left_margin(cm_navbar_item_element, cm_navbar_dropdown_container) {
    // 取得當下瀏覽器畫面寬度
    const BrowserScreenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    // #cm_navbar_dropdown_container中所有子元素的總寬度
    const var_cm_navbar_dropdown_all_item_width_total = cm_tenavbar_dropdown_all_item_width_total(cm_navbar_dropdown_container);
    // #cm_navbar_dropdown_container的中心點y軸
    const var_navbar_dropdown_center_point_width = var_cm_navbar_dropdown_all_item_width_total / 2;
    // 計算出#cm_navbar_dropdown_container的margin-left需為多少
    let navbar_dropdown_item_left_margin = (cm_screen_to_navbar_item_triger_center_point(cm_navbar_item_element) - var_navbar_dropdown_center_point_width);
    // 判斷(#cm_navbar_dropdown_container的margin-left + 二級navbar的總寬度)是否超過當下瀏覽器畫面寬度
    if ((navbar_dropdown_item_left_margin + var_cm_navbar_dropdown_all_item_width_total) + 50 > BrowserScreenWidth) {
        // 因為超過，所以重算#cm_navbar_dropdown_container的margin-left
        navbar_dropdown_item_left_margin = (BrowserScreenWidth - var_cm_navbar_dropdown_all_item_width_total) / 2;
    }
    document.querySelector("#cm-navbar-dropdown-container").style["padding-left"] = (navbar_dropdown_item_left_margin + 22) + "px";
}


// #cm_navbar_dropdown_container中所有子元素的總寬度
function cm_tenavbar_dropdown_all_item_width_total(cm_navbar_dropdown_container) {
    const cm_navbar_dropdown_container_element = document.querySelector("#" + cm_navbar_dropdown_container);
    let all_child_width = 0;
    for (let i = 0; i < cm_navbar_dropdown_container_element.children.length; i++) {
        let child_width = cm_navbar_dropdown_container_element.children[i].offsetWidth;
        // 解決寬度有小數點導致每一次取值會亂跳的問題
        if((child_width%2) == 0) {
            child_width += 1;
        }
        all_child_width += child_width;
    }
    return all_child_width;
}


// 從螢幕最左方至navbar中被觸發的元素中心點的width
function cm_screen_to_navbar_item_triger_center_point(cm_navbar_item_element) {
    return cm_navbar_item_element.getBoundingClientRect().left + (cm_navbar_item_element.offsetWidth / 2) - 22; // 22是依照畫面調整得到的值
}


/**
 * 初始化導覽列
 */
function cm_navbar_initial() {

    // 取得一級item的上層.cm-navbar-dropdown-listener
    const cm_navbar_dropdown_listener = document.querySelector(".navbar-nav.cm-navbar-dropdown-listener");

    /**
     * 對一級item的上層綁定mousemove
     */
    cm_navbar_dropdown_listener.addEventListener("mousemove", function (event) {
        // #cm-navbar-dropdown-container區塊清空
        document.querySelector("#cm-navbar-dropdown-container").innerHTML = "";
        // 被觸發的元素
        cm_navbar_item_trigger = event.target;

        // 被觸發元素如果存在二級list
        if (cm_navbar_item_trigger.parentElement.querySelector('.cm-navbar-dropdown-list') != null) {
            // 被觸發元素的二級list
            const cm_navbar_dropdown_list = cm_navbar_item_trigger.parentElement.querySelector('.cm-navbar-dropdown-list').cloneNode(true);
            // #cm-navbar-dropdown-bar打開
            document.querySelector("#cm-navbar-dropdown-bar").style.display = "block";
            // #cm-navbar-dropdown-container排版改為flex
            document.querySelector("#cm-navbar-dropdown-container").style.display = "flex";
            // 將二級item附加到#cm-navbar-dropdown-container
            while (cm_navbar_dropdown_list.children.length > 0) {
                document.querySelector("#cm-navbar-dropdown-container").appendChild(cm_navbar_dropdown_list.children[0]);
            }
            cm_navbar_dropdown_container_add_left_margin(cm_navbar_item_trigger, cm_navbar_dropdown_container);


            /**
             * 二級cm_navbar_dropdown_bar綁定mousemove和mouseout事件
             */
            const cm_navbar_dropdown_bar_element = document.querySelector("#cm-navbar-dropdown-bar");
            // #cm-navbar-dropdown-bar綁定mousemove
            cm_navbar_dropdown_bar_element.addEventListener("mousemove", cm_navbar_dropdown_bar_mousemove);
            // #cm-navbar-dropdown-bar綁定mouseout
            cm_navbar_dropdown_bar_element.addEventListener("mouseout", cm_navbar_dropdown_bar_mouseout);
        }
    })


    /**
     * 對一級item的上層綁定mouseout
     */
    cm_navbar_dropdown_listener.addEventListener("mouseout", function (event) {
        setTimeout(function () {
            if (document.querySelector("#cm-navbar-dropdown-bar").dataset["hide"] == "true") {
                // 隱藏
                document.querySelector("#cm-navbar-dropdown-bar").style.display = "none";
                document.querySelector("#cm-navbar-dropdown-container").style.display = "none";

                // 移除#cm-navbar-dropdown-bar的mousemove和mouseout事件
                document.querySelector("#cm-navbar-dropdown-bar").removeEventListener("mousemove", cm_navbar_dropdown_bar_mousemove);
                document.querySelector("#cm-navbar-dropdown-bar").removeEventListener("mouseout", cm_navbar_dropdown_bar_mouseout);

                // 清除觸發的元素
                cm_navbar_item_trigger = null;
            }
        }, 100);
    })
}


/**
 * 初始化手機版navbar相關事件
 */
function cm_navbar_mobile_init() {
    // 手機版navbar展開後的事件
    $("#cm-navbar-button").on('shown.bs.collapse', function () {
        // 1.navbar第一次展開，將navbar展開的高度記錄到元素的data中
        // 2.判斷展開的navbar是否需要設置成可上下滑動
        if(document.querySelector(".navbar-nav.cm-navbar-dropdown-listener").dataset.navbardropdownheight == undefined) {
            // 將navbar展開的高度記錄到元素的data中
            const navbarDropdownHeight = document.querySelector(".navbar-nav.cm-navbar-dropdown-listener").offsetHeight;
            document.querySelector(".navbar-nav.cm-navbar-dropdown-listener").dataset.navbardropdownheight = navbarDropdownHeight;

            // 當navbar展開的高度 > 螢幕高度，將展開的navbar設置成可上下滑動
            const browserScreenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            if((navbarDropdownHeight+mobileBrandDivHeight) > browserScreenHeight) {
                document.querySelector('#cm-navbar-button').style.maxHeight = (browserScreenHeight - mobileBrandDivHeight) + "px";
                document.querySelector('#cm-navbar-button').style.overflowY = "scroll";
            }
        }
        
        document.querySelector(".wrapper").addEventListener("click", cm_navbar_mobile_dropdown);
        
    });

    // 手機版navbar關閉後的事件
    $("#cm-navbar-button").on('hidden.bs.collapse', function () {
        document.querySelector(".wrapper").removeEventListener("click", cm_navbar_mobile_dropdown);
    });

    // 當點選手機版navbar中的項目時，如果該項目沒有子項目則navbar自動縮回
    cm_navbar_mobile_click_item_auto_close();
}


/**
 * 偵測手機版navbar展開後是否要賦予上下滑動功能
 */
function cm_navbar_mobile_overflowy_detect() {
    const browserScreenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const browserScreenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const navbarDropdownHeight = document.querySelector(".navbar-nav.cm-navbar-dropdown-listener").dataset.navbardropdownheight;
    if(browserScreenWidth > 768) {
        document.querySelector('#cm-navbar-button').style.overflowY = "hidden";
    }
    else if(navbarDropdownHeight != undefined) {
        const navbarDropdownHeight = parseInt(document.querySelector(".navbar-nav.cm-navbar-dropdown-listener").dataset.navbardropdownheight);
        if(browserScreenHeight > (navbarDropdownHeight+mobileBrandDivHeight)) {
            document.querySelector('#cm-navbar-button').style.maxHeight = navbarDropdownHeight + "px";
            document.querySelector('#cm-navbar-button').style.overflowY = "hidden";
        }
        else {
            document.querySelector('#cm-navbar-button').style.maxHeight = (browserScreenHeight - mobileBrandDivHeight) + "px";
            document.querySelector('#cm-navbar-button').style.overflowY = "scroll";
        }
    }
}


/**
 * 二級導覽列常駐時(如平板)動態位置判斷
 */
function cm_navbar_dynamic_dropdown_container_position() {
    // 隨螢幕變化計算二級navbar位置
    if (cm_navbar_item_trigger != null) {
        cm_navbar_dropdown_container_add_left_margin(cm_navbar_item_trigger, cm_navbar_dropdown_container);
    }
}


/**
 * 手機版的navbar是否為展開中
 */
function cm_navbar_mobile_is_show() {
    if(document.querySelector("#cm-navbar-button").classList.contains("show")) {
        return true;
    }
    return false;
}


/**
 * 關閉手機版展開中的navbar
 */
function cm_navbar_mobile_close() {
    if(cm_navbar_mobile_is_show()) {
        $("#cm-navbar-button").collapse("toggle");
    }
}


/**
 * 當點選手機版navbar中的項目時，如果該項目沒有子項目則navbar自動縮回
 */
function cm_navbar_mobile_click_item_auto_close() {
    document.querySelector(".cm-navbar-dropdown-listener").addEventListener("click", function (event) {
        if (cm_navbar_mobile_is_show()) {
            let targetEle = event.target;

            if (targetEle.classList.contains("nav-link") && !targetEle.classList.contains("dropdown-toggle")) { // 一級導覽列的項目沒有子項目
                cm_navbar_mobile_close()
            }
            else if (targetEle.parentNode.classList.contains("dropdown-menu")) { // 一級導覽列的項目的子項目的父元素(div)是否包含dropdown-menu
                cm_navbar_mobile_close()
            }
        }
    });
}


/**
 * 當手機版navbar展開時，判斷點擊的位置是否為navbar區塊，如果不是則收起navbar
 */
function cm_navbar_mobile_dropdown(event) {
    if(event.target.classList.length > 0) {
        // 用觸發元素的class判斷該元素是否在#cm-navbar-container底下
        // 如果觸發元素是#cm-navbar-container的子元素，則不關閉展開中的navbar
        let elementClassList = event.target.classList;
        let contactHtmlClass = "";
        for(let i=0; i<elementClassList.length; i++) {
            contactHtmlClass += "." + elementClassList[i]
        }
        let elementArray = document.querySelectorAll("#cm-navbar-container " + contactHtmlClass);
        if(elementArray.length == 0) {
            cm_navbar_mobile_close();
        }
    }
    else {
        cm_navbar_mobile_close();
    }
}

export {
    cm_navbar_initial,
    cm_navbar_dynamic_dropdown_container_position,
    cm_navbar_mobile_init,
    cm_navbar_mobile_overflowy_detect,
    cm_navbar_mobile_close
}